import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBottomNavStore = defineStore('bottomNav', () => {
    const showBottomNav = ref(false)

    function setBottomNavVisibility(value) {
        showBottomNav.value = value
    }

    return {
        showBottomNav,
        setBottomNavVisibility
    }
})